import { render, staticRenderFns } from "./ContratoTexto.vue?vue&type=template&id=d6e4a41e&"
import script from "./ContratoTexto.vue?vue&type=script&lang=js&"
export * from "./ContratoTexto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports